import {Breadcrumb, Divider} from 'antd';
import React from 'react';
import style from "./index.module.css"
import {useLocation, useNavigate} from "react-router-dom";
import CompanyDescription from "../../components/companyDescription";
import CompanyStructure from "../../components/companyStructure";
import CertificateNavModule from "../../components/certificateNavModule";

const SecondPage = () => {
    const locaton = useLocation();
    const navigate = useNavigate();
    let subPath = locaton?.state?.subPath;

    const baseItem = [
        {
            title: <div>首页</div>,
        },
        {
            title: "关于我们",
        },
    ];

    switch (subPath) {
        case "c1":
            baseItem.push({
                title: "机构简介",
            });
            break;
        case "c2":
            baseItem.push({
                title: "组织架构",
            });
            break;
        default:
            // 如果需要处理其他情况，可以加上 default 分支
            break;
    }

    return (
        <div className={style.pageContainer}>
            <Breadcrumb
                items={baseItem}
            />
            <div className={style.content}>
                <div className={style.leftNavBar}>
                    <div className={subPath === "c1" ? style.leftNavBarBtnPushed : style.leftNavBarBtn} onClick={() => {
                        navigate("/about", {state: {subPath: "c1"}})
                    }}>机构简介
                    </div>
                    <div className={subPath === "c2" ? style.leftNavBarBtnPushed : style.leftNavBarBtn} onClick={() => {
                        navigate("/about", {state: {subPath: "c2"}})
                    }}>组织架构
                    </div>
                    <div style={{height:60}}/>
                    <CertificateNavModule />
                </div>

                <div className={style.rightMainContainer}>
                    <div>
                        <div className={style.pageTitle}>关于我们</div>
                        <Divider style={{padding: '0 30px', borderColor: '#043554'}}>ABOUT US</Divider>
                    </div>
                    <div className={style.articleContainer}>
                        {subPath === "c1" ? (<CompanyDescription/>)
                            : subPath === "c2" ? (<CompanyStructure/>)
                                : (<div/>)}
                    </div>
                </div>
            </div>
        </div>
    );
};


export default SecondPage;